export default __webpack_public_path__ + "static/media/single_choice_colour.b0c57131.svg";